import { ColumnDef } from '@tanstack/react-table';

import { TripListRead, TripRead } from 'src/common/external/bambi-api/bambiApi';
import {
  dropoffAddressColumnDef,
  passengerColumnDef,
  payerColumnDef,
  pickupAddressColumnDef,
  pickupTimeColumnDef,
  scheduledPickupAtColumnDef,
} from 'src/features/trip/management/TripManagementDataGrid/columns';

export const bulkPriceTripsModalColumns: ColumnDef<
  TripRead | TripListRead,
  any
>[] = [
    passengerColumnDef,
    scheduledPickupAtColumnDef,
    pickupTimeColumnDef,
    pickupAddressColumnDef,
    dropoffAddressColumnDef,
    payerColumnDef
  ];